import { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { fieldSx } from "./authStyles";

// Label sits above the input (easier to scan than floating labels)
export const AuthField = ({ id, label, error, hint, InputProps, ...rest }) => (
  <div>
    <label
      htmlFor={id}
      className="mb-1.5 ml-1 block text-[0.9rem] font-medium text-ink"
    >
      {label}
    </label>
    <TextField
      id={id}
      name={id}
      fullWidth
      variant="outlined"
      error={Boolean(error)}
      helperText={error || hint}
      sx={fieldSx}
      InputProps={InputProps}
      {...rest}
    />
  </div>
);

export const PasswordField = ({
  id = "password",
  label = "Password",
  ...rest
}) => {
  const [show, setShow] = useState(false);
  return (
    <AuthField
      id={id}
      label={label}
      type={show ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShow((s) => !s)}
              aria-label={show ? "Hide password" : "Show password"}
              edge="end"
              sx={{ marginRight: "6px" }}
            >
              {show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};
